"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = require("./constants");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var ActionBar = function ActionBar(_ref) {
  var _ref$id = _ref.id,
      id = _ref$id === void 0 ? _constants.NAMESPACES.GENERIC_ACTION_BAR : _ref$id,
      _ref$testId = _ref.testId,
      testId = _ref$testId === void 0 ? '' : _ref$testId,
      _ref$order = _ref.order,
      order = _ref$order === void 0 ? _constants.ORDER_CLASSNAMES.GENERIC_ACTION_BAR : _ref$order,
      className = _ref.className,
      _ref$noMargin = _ref.noMargin,
      noMargin = _ref$noMargin === void 0 ? false : _ref$noMargin,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["id", "testId", "order", "className", "noMargin", "children"]);

  var classes = (0, _classnames2.default)(className, {
    mb5: !noMargin
  }, order);
  return _react2.default.createElement("div", _extends({
    id: id,
    "data-testid": testId,
    className: classes
  }, props), children);
};

exports.default = ActionBar;